<template>
  <div>
    <div v-if="!profilePicture" class="picture">
      <img class="profile-picture" src="../../../../assets/images/user-placeholder.png"/>
      <div class="file-input custom">
        <span>Upload picture</span>
        <input accept="image/*" type="file" id="file" value="upload" @change="fileBtn(file, $event)">
      </div>
    </div>
    <div v-if="profilePicture" class="picture">
      <img :v-if="!profilePicture" class="profile-picture" :src="profilePicture" alt=""/>
      <div class="file-input custom">
        <span>Upload picture</span>
        <input accept="image/*" type="file" id="file" value="upload" @change="fileBtn(file, $event)">
      </div>
    </div>
  </div>
</template>

<script>
  import * as firebaseStorage from '../../../../API/firebaseStorage'
  import firebase from 'firebase'

  export default {
    name: "profile-avatar",
    data() {
      return {
        profilePicture: '',
        file: '',
      }
    },
    methods: {
      fileBtn: function (file, e) {

        e.preventDefault();
        //get file
        let getFile = e.target.files[0];
        //set storage ref

        firebase.auth().onAuthStateChanged((user)=> {
          if (user) {
            // User is signed in.
            //  let storageRef = firebase.storage().ref('userAvatar/'+user.uid);

            firebaseStorage.uploadFile('userAvatar', getFile, user.uid).then(success => {
              this.$message('image uploaded');
            }).catch(err => {
              console.log(err);
            });

          } else {
            // No user is signed in.
          }

        })

      },

    },
    created(){
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          firebaseStorage.downloadFile('userAvatar', user.uid).then(url => {
            this.profilePicture = url;
          }).catch(error => {

            console.log('user has no avatar')
          });
        }
      });
    }
  }
</script>

<style lang="scss" scoped>
  .picture {

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .profile-picture {
      width: 150px;
      height: 150px;
      display: block;
      border-radius: 50%;
      border: 2px solid #888;
      margin-bottom: 20px;
      margin-top: 80px;
    }
    .file-input {
      pointer-events: none;
      position: relative;
      overflow: hidden;
      cursor: pointer;
      &.custom {
        background-color: #fff;
        border-radius: 8px;
        border: solid 1px;
        border-color: #aaa;

        padding: 6px 12px;
        text-align: center;
        color: #000;
      }
      > * {
        pointer-events: all;
      }
      > input[type="file"] {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        opacity: 0;
        pointer-events: all;
        cursor: pointer;
        height: 100%;
        width: 100%;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/layout/components/profile/ProfileAvatar.vue